let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lk62y")).then(() => parcelRequire('573SD'));